import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isDisableResourceRequestFailure({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isFailure : false;
    },
    isDisableResourceRequestPending({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isPending : false;
    },
    isDisableResourceRequestSuccess({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
